import { Component, Input } from '@angular/core';
import { UserUtils } from "../../../ui-utils/user-utils";
import { ConversationData, DateUtils } from "../../..";
import { TranslateService } from "@ngx-translate/core";
var HTML_TEMPLATE = "\n<div *ngIf=\"_data !=null\" class=\"od-conversation\" [ngClass]=\"{'od-conversation-unread':!_data.read}\">\n\t<div *ngIf=\"_data.requesters !=null && _data.requesters.length > 0\" class=\"od-conversation-requesters\" >\n\t\t<od-decorated-avatar [data]=\"_data.requesters[0]\" class=\"od-conversation-requester\"></od-decorated-avatar>\n\t</div>\n\t<div class=\"od-conversation-info\">\n\t    <div class=\"od-conversation-requester-name\">{{ getUserDisplayNameFirstRequester() }}</div>\n\t    <div class=\"od-conversation-info-bottom\">\n\t    \t{{ getLastMessageDate() }}\n\t\t    <div *ngIf=\"_data.messages!=null\" class=\"od-conversation-user-last-message\">\n\t\t\t\t<p class=\"od-conversation-user-last-message-author\"> {{ getLastMessageAuthor() }}</p>\n\t\t\t\t<p class=\"od-conversation-user-last-message-description\"> {{ getLastMessageText() }}</p>\n\t\t\t</div>\n\t    \t<div *ngIf=\"_data.requesters != null && _data.requesters.length > 0\" class=\"od-conversation-num-participants\">{{ getNumberOfParticipants() }}</div>\n\t\t\t<div *ngIf=\"false\" [class]=\"'od-conversation-status-'+_data.status\">{{_data.status}}</div>\n\t    </div>\n  \t</div>\n    <div *ngIf=\"_data.messages!=null && _dateOfLastMessageTimeAgo !=null\" class=\"od-conversation-user-last-message-date\">\n\t\t<p style=\"margin: 0 5px\">{{ _dateOfLastMessageTimeAgo }}</p>\n\t</div>\n\t<div *ngIf=\"_data.messages!=null && _dateOfLastMessageTimeAgo == null\" class=\"od-conversation-user-last-message-date\">\n\t\t<p style=\"margin: 0 5px\">{{_dateOfLastMessage | date: 'EEEEEE, MMMM d, y' }} </p>\n\t</div>\n</div>\n\n";
var CSS_STYLE = "\n.od-conversation {\n    display: block;\n\talign-items: center;\n\tpadding-top: 0px;\n\tpadding-bottom: 4px;\n\tmargin-bottom: 2px;\n\tposition: relative;\n\twidth: 100%;\n}\n\n.od-conversation-requesters {\n    position: relative;\n    min-width: 48px;\n    min-height: 40px;\n    margin: 0;\n    margin-top: 10px;\n    float: left;\n}\n\n.od-conversation .od-conversation-requester{\n    top:0;\n    position: absolute;\n}\n\n.od-conversation-info {\n\tflex-grow: 1;\n    padding-top: 12px;\n}\n\n.od-conversation-requester-name {\n\theight: 16px;\n\tfont-family: Lato;\n\tfont-size: 14px;\n\tfont-weight: 700;\n\tfont-style: normal;\n\tfont-stretch: normal;\n\tline-height: 1.14;\n\tletter-spacing: normal;\n\ttext-align: left;\n\tcolor: #354052;\n}\n\n.od-conversation-user-last-message-date p,\n.od-conversation-user-last-message p {\n\theight: 16px;\n\tfont-family: Lato;\n\tfont-size: 11px;\n\tfont-weight: 600;\n\tfont-style: normal;\n\tfont-stretch: normal;\n\tline-height: 1.6;\n\tletter-spacing: normal;\n\tcolor: #9a9fa8;\n}\n\n.od-conversation-user-last-message{\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n}\n\n.od-conversation-user-last-message-date{\n    position: absolute;\n    right: 0;\n    top: 14px;\n    width: auto;\n}\n\n.od-conversation-info-bottom {\n  display: flex;\n}\n\n.od-conversation-num-participants{\n  height: 16px;\n  font-family: Lato;\n  font-size: 11px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.45;\n  letter-spacing: normal;\n  color: #9a9fa8;\n}\n\n.od-conversation-datetime{\n  color: #9a9fa8;\n}\n\n.od-conversation-datetime,\n.od-conversation-status-open,\n.od-conversation-status-close{\n  font-size: 12px;\n  padding: 2px 0 4px;\n}\n\n.od-conversation-unread .od-conversation-requester-name{\n\tcolor: #1d9ac0;\n}\n\n.od-conversation-unread .od-conversation-requester-name:before{\n\tcontent: '.';\n    font-size: 24px;\n    line-height: 1px;\n    position: absolute;\n    left: 1.7em;\n}\n\n.od-conversation-status-open,\n.od-conversation-status-close{\n\tpadding-left:8px;\n}\n\n.od-conversation-status-open{\n\tcolor:#45b854;\n}\n.od-conversation-status-close{\n\tcolor:#e75252;\n}\n\n.od-conversation-user-last-message-author {\n\tflex: 0 0 auto;\n\tmargin: 0 5px 0 0;\n}\n\n.od-conversation-user-last-message-description{\n\ttext-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n\tmargin: 0;\n\tmax-width: 1150px;\n}\n";
var Conversation = /** @class */ (function () {
    function Conversation(_translate) {
        var _this = this;
        this._translate = _translate;
        this._textLessThan1Min = "";
        this._textDay = "";
        this._textHour = "";
        this._textMin = "";
        this._translate.get("Conversations.lessThan1Min").subscribe(function (res) { return _this._textLessThan1Min = res; });
        this._translate.get("Conversations.day").subscribe(function (res) { return _this._textDay = res; });
        this._translate.get("Conversations.hour").subscribe(function (res) { return _this._textHour = res; });
        this._translate.get("Conversations.min").subscribe(function (res) { return _this._textMin = res; });
    }
    Object.defineProperty(Conversation.prototype, "data", {
        set: function (value) {
            this._data = value;
        },
        enumerable: true,
        configurable: true
    });
    Conversation.prototype.timeRender = function () {
        this._isToday = DateUtils.isToday(this._dateOfLastMessage);
        if (this._isToday) {
            this._dateOfLastMessageTimeAgo = this.getTimeAgo();
        }
        else if (!this._isToday) {
            clearInterval(this._timeInterval);
        }
    };
    Conversation.prototype.getUserDisplayNameFirstRequester = function () {
        if (this._data.requesters != null && this._data.requesters.length > 0) {
            return UserUtils.getDisplayName(this._data.requesters[0]);
        }
        return "";
    };
    Conversation.prototype.getNumberOfParticipants = function () {
        if (this._data.requesters != null && this._data.requesters.length > 1) {
            return "+" + (this._data.requesters.length - 1) + " more";
        }
        return "";
    };
    Conversation.prototype.getLastMessageDate = function () {
        var _this = this;
        if (this._data != null) {
            this._dateOfLastMessage = this.getDateOfLastMessage();
            this.timeRender();
            if (this._timeInterval != null)
                clearInterval(this._timeInterval);
            this._timeInterval = setInterval(function () { return _this.timeRender(); }, 1000);
        }
    };
    Conversation.prototype.getLastMessageText = function () {
        if (this._data.messages != null && this._data.messages.length > 0) {
            var lastMessage = null;
            for (var _i = 0, _a = this._data.messages; _i < _a.length; _i++) {
                var message = _a[_i];
                if (lastMessage == null || lastMessage.createdDate < message.createdDate) {
                    lastMessage = message;
                }
            }
            if (lastMessage != null) {
                // !!! don't use this hack because it produces infinit refresh at ts
                // let div: HTMLDivElement = document.createElement("div");
                // div.innerHTML = lastMessage.text;
                // return "\"" + div.innerText + "\" ";
                // return lastMessage.text.replace(/<[^>]*>?/gm, '');
                return this.strip(lastMessage.text);
            }
        }
        return "";
    };
    Conversation.prototype.strip = function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    };
    Conversation.prototype.getLastMessageAuthor = function () {
        if (this._data.messages != null && this._data.messages.length > 0) {
            var lastMessage = null;
            for (var _i = 0, _a = this._data.messages; _i < _a.length; _i++) {
                var message = _a[_i];
                if (lastMessage == null || lastMessage.createdDate < message.createdDate) {
                    lastMessage = message;
                }
            }
            if (lastMessage != null)
                return UserUtils.getDisplayName(lastMessage.author) + ":";
        }
        return "";
    };
    Conversation.prototype.getDateOfLastMessage = function () {
        if (this._data.messages != null && this._data.messages.length > 0) {
            var lastMessage = null;
            for (var _i = 0, _a = this._data.messages; _i < _a.length; _i++) {
                var message = _a[_i];
                if (lastMessage == null || lastMessage.createdDate < message.createdDate) {
                    lastMessage = message;
                }
            }
            if (lastMessage != null)
                return lastMessage.createdDate;
        }
        return new Date();
    };
    Conversation.prototype.getTimeAgo = function () {
        var currentTimeSec = Date.now();
        var differenceSec = (currentTimeSec - this._dateOfLastMessage.getTime()) / 1000;
        var hours = Math.floor(differenceSec / 3600);
        var days = hours / 24;
        var min = Math.floor((differenceSec % 3600) / 60);
        var timeAgo = null;
        if (hours <= 0 && min <= 0) {
            timeAgo = this._textLessThan1Min;
        }
        else if (hours <= 0 && min > 0) {
            timeAgo = min + this._textMin;
        }
        else if (hours <= 23 && hours > 0) {
            timeAgo = hours + this._textHour;
        }
        else if (days <= 27 && days > 0) {
            timeAgo = days + this._textDay;
        }
        return timeAgo;
    };
    Conversation.decorators = [
        { type: Component, args: [{
                    selector: 'od-conversation',
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    Conversation.ctorParameters = function () { return [
        { type: TranslateService, },
    ]; };
    Conversation.propDecorators = {
        "data": [{ type: Input },],
    };
    return Conversation;
}());
export { Conversation };
//# sourceMappingURL=conversation.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui/chat/conversation/conversation.js
// module id = 433
// module chunks = 14